import { Button } from '@bcecloud/portal-ui';
import type { RepWriteApplied } from '@/lib/sales-workspace';

/**
 * What a write did, when the screen alone would not show it: a dry run
 * (nothing reached Salesforce), or a live write the mirror has not caught up
 * with yet. A live write that patched the mirror needs no notice: the page
 * already shows it.
 *
 * @param props - The last write's result and a dismiss handler.
 * @returns The notice, or null.
 */
export function DryRunNotice({
  result,
  onDismiss,
}: {
  readonly result: RepWriteApplied;
  readonly onDismiss: () => void;
}): React.ReactElement | null {
  const message =
    result.mode === 'dry-run'
      ? 'Dry run: Salesforce was not changed. Changes are saved for real only in production.'
      : !result.mirrorPatched
        ? 'Saved in Salesforce. It shows here after the next sync, within five minutes.'
        : null;
  if (message === null) return null;
  return (
    <p role="status" className="mb-4 flex items-center justify-between gap-3 rounded-portal-card bg-brand-tint p-3 text-portal-small text-brand">
      <span>{message}</span>
      <Button variant="ghost" size="compact" onClick={onDismiss}>
        Dismiss
      </Button>
    </p>
  );
}
